import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["disabled", "onClick"]

import { computed, ref, watch, onMounted, onBeforeUnmount } from "vue";
import { useVoting } from "@/use/useVoting";
import UiIcon from "@/plugins/ui/components/icon/UiIcon.vue";
// import UiCaption from "@/plugins/ui/components/typography/UiTitle.vue";
// import UiCaption from "@/plugins/ui/components/typography/UiCaption.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'VotingElement',
  setup(__props) {

const ratingElements = ref<number>(5);
const currentRating = ref<number>(0);
const isLoading = ref(true);
const loading = ref<boolean>(false);
const response = ref<string | null>(null);
let timer: ReturnType<typeof setTimeout> | null = null;

const responseText = "Спасибо! Ваш голос принят.";

const { getVoting, setVoting } = useVoting();

async function setRating(index: number) {
  if (loading.value) return;
  loading.value = true;
  try {
    currentRating.value = index;
    await setVoting(currentRating.value);
  } catch (error: any) {
    // console.error("Ошибка при установке рейтинга:", error);
  } finally {
    loading.value = false;
  }
}

watch(currentRating, () => {
  if (timer) {
    clearTimeout(timer);
  }

  response.value = responseText;

  timer = setTimeout(() => {
    response.value = null;
  }, 5000);
});

onMounted(async () => {
  const currentValue = await getVoting();
  currentRating.value = Number(currentValue.value);
  isLoading.value = false;
});

onBeforeUnmount(() => {
  if (timer) {
    clearTimeout(timer);
  }
  isLoading.value = true;
});

return (_ctx: any,_cache: any) => {
  return (!isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ratingElements.value, (index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            disabled: loading.value,
            class: "items-center justify-center",
            style: {"position":"relative","display":"inline-block"},
            onClick: () => setRating(index)
          }, [
            _createVNode(UiIcon, {
              icon: "Star",
              solid: index <= currentRating.value,
              color: index <= currentRating.value ? '#FCD34D' : '#D1D1D1',
              style: {"position":"relative","z-index":"1"}
            }, null, 8, ["solid", "color"]),
            (index <= currentRating.value)
              ? (_openBlock(), _createBlock(UiIcon, {
                  key: 0,
                  icon: "Star",
                  solid: false,
                  color: '#FCD34D',
                  style: {"position":"absolute","top":"0","left":"0","z-index":"0"}
                }))
              : _createCommentVNode("", true)
          ], 8, _hoisted_2))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})